import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../services/api/API";
import { useLocation } from "react-router-dom";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import addIcon from "../../../../../Assets/icons/addIconLogistics.svg";
import deleteIcon from "./../../../../../Assets/icons/trash.svg";
import CustomTable from "../../../../customComponents/CustomTable";
import { set } from "date-fns";
import SerialForm from "../../PhysicalStockTaking/PhysicalStockinComponents/SerialForm";
import StockInSerialForm from "./StockInSerialForm";
// import SerialForm from "./SerialForm";

const StockInSerial = ({
  PhysicalStockinId,
  businessPartnerIdValue,
  poDetailsId,
  showroomIdVal,
  itemTypeValue,
  poIdValue,
  vendorId,
  itemNameData,
  isEdit,
  toggleSerialDrawer=()=>{},
  activeComponent,
  phyItemId,
  setIsEdit,
  formData,
  setFormData,
  serialFormData,
  setserialFormData=()=>{},
  isSerailDrawerOpen,
  serialData,
  businessPartnerIdState
}) => {
  // const [formData, setserialFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [userTypedd, setUserTypedd] = useState([]);
  const [iseditmode, setisEditMode] = useState(false);
  const [serialList, setSerialList] = useState([]);
  const userType = localStorage.getItem("UserType");
  const [variantId, setVariantId] = useState(0);
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const token = localStorage.getItem("authToken");
  const location = useLocation();
  const PODETAILSID = location?.state?.data?.po_details_id
  console.log("seraillocationdata", location);
  const [serialID,setSerialId] = useState(null)

  const [ poStockInId, setPoStockInId ] = useState()


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchDepartments(newPage);
  };
  const fetchDepartments = async (page = 0, pageSize = 10) => {
    try {
      const response = await axiosInstance.post(
        "/Postockin/srnolist",
        {
          orderBy: "postockinsr_id desc",
          page,
          pageSize,
          po_details_id:poDetailsId ||PODETAILSID
        //   phystkinitem_id: serialData?.phystkin_item_id,
        //   phystkin_id: PhysicalStockinId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      setTotalRecords(totalRecordsData);

      const postockinId = formattedData[0].postockinsr_id
      setPoStockInId(postockinId)
      console.log(postockinId, "POST")

      setSerialList(formattedData);
      
      console.log("response", response);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };
  useEffect(() => {
    userTypedropdown();
    if(isSerailDrawerOpen){
      fetchDepartments();
      setValidationErrors({})
    }
   
  }, [isSerailDrawerOpen]);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

 
  

const Serial_TABLE_HEADERS = [
    "Chassis No.",
    "Engine No.",

    "Serial No.",
    "Action",
  ];
  const Serial_KEY_MAPPING = {
    "Chassis No.": "chassis_no",
    "Engine No.": "engine_no",

    "Serial No.": "serial_no",
    Action: [
      { type: "edit", icon: editIcon, label: "Edit" },
    //   { type: "delete", icon: deleteIcon, label: "Delete" },
    ],
  };

 
    // const fetchSparePartExistingDetails = async () => {
    //   console.log("serialData",serialData);

    //   try {
    //     const response = await axiosInstance.get(
    //       `/Postockin/srnoedit/${serialID}`,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //         },
    //       }
    //     );

    //     if (response.status === 200) {
    //       const vehicleData = response.data.data;
    //       console.log("vehicledata", vehicleData, response);

    //       const transformedData = {
    //         business_partner_id: vehicleData?.business_partner_id,
    //         chassisno: vehicleData.chassis_no,
    //         engineno: vehicleData.engine_no,
    //         serialno: vehicleData?.serial_no,
    //       };

    //       setFormData(transformedData);

    //       console.log(
    //         "Transformed vehicle data set to formData:",
    //         transformedData
    //       );
    //     } else {
    //       console.error("Failed to fetch vehicle data");
    //     }
    //   } catch (error) {
    //     console.error("Error fetching vehicle data:", error);
    //   }
    // };

  

  const handleEdit = (rowData) => {
    console.log("rowData>>", rowData);
    const fetchSparePartExistingDetails = async () => {
      console.log("serialData",serialData);

      try {
        const response = await axiosInstance.get(
          `/Postockin/srnoedit/${rowData?.postockinsr_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          const vehicleData = response.data.data;
          console.log("vehicledata", vehicleData, response);

          const transformedData = {
            business_partner_id: vehicleData?.business_partner_id,
            chassisno: vehicleData.chassis_no,
            engineno: vehicleData.engine_no,
            serialno: vehicleData?.serial_no,
          };

          setFormData(transformedData);

          console.log(
            "Transformed vehicle data set to formData:",
            transformedData
          );
        } else {
          console.error("Failed to fetch vehicle data");
        }
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      }
     
    };
    setSerialId(rowData?.po_details_id)
    fetchSparePartExistingDetails()
    setisEditMode(true);
  };

  const handleDelete = async (rowData) => {
    console.log("rowData>>>>", rowData);

    try {
      const response = await axiosInstance.delete(
        `/physicalstocktakeitemserial/delete/${serialID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Create a new array without the deleted item
        const updatedData = serialList.filter(
          (item) => item.phystockinsr_id !== rowData.phystockinsr_id
        );
        setSerialList(updatedData);
        console.log("Item deleted successfully");
      } else {
        console.error("Failed to delete item");
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };


  return (
    <div className="mt-1 mb-3">
      <StockInSerialForm formData={formData} setFormData={setFormData} itemTypeValue={itemTypeValue} itemNameData={itemNameData} showroomIdVal={showroomIdVal} poIdValue={poIdValue} serialData={serialData} serialID ={serialID} fetchDepartments={fetchDepartments} iseditmode={iseditmode} poDetailsId={poDetailsId} setisEditMode={setisEditMode} businessPartnerIdValue={businessPartnerIdValue}
      toggleSerialDrawer={toggleSerialDrawer} poStockInId={poStockInId}
    />
    
      <div className="mt-3">
        <CustomTable
          data={serialList}
          headers={Serial_TABLE_HEADERS}
          keyMapping={Serial_KEY_MAPPING}
          itemsPerPage={10}
          totalRecords={totalRecords} 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onDelete={handleDelete}
          onEdit={handleEdit}
        />
      </div>
      
    </div>
  );
};

export default StockInSerial;
